import {equals, flatten, get, merge, pipe, reduce, toDefaultZero} from '@logistics-frontend/utils'

import type {DestinationPoint, PointID, Product, SddClaimProduct} from 'src/shared/types'
import {ParcelPaymentType} from 'src/shared/types'
import {fromSddExpressProduct, getPointId, getProducts, toFiscalizaitonIfPaymentOnDemand} from 'src/shared/utils'

export function fromSddExpressParcel(sourcePointId: PointID, destinationPoints: DestinationPoint[]): SddClaimProduct[] {
  return pipe(
    destinationPoints,
    reduce<DestinationPoint, SddClaimProduct[][]>((acc, destination) => {
      const destinationPointId = pipe(destination, getPointId, toDefaultZero)
      const products: Product[] = getProducts(destination)
      const isPaymentOnDemand = pipe(destination, get('parcels[0].payment'), equals(ParcelPaymentType.OnDemand))

      const cargoItems = products.map(product =>
        merge(fromSddExpressProduct(product), {
          pickup_point: sourcePointId,
          droppof_point: destinationPointId,
          fiscalization: toFiscalizaitonIfPaymentOnDemand(product, isPaymentOnDemand),
        }),
      )

      acc.push(cargoItems)

      return acc
    }, []),
    flatten,
  )
}
